module.exports = __webpack_public_path__ + "static/img/1000000534_blue.b7276a17.jpg";